
import { defineComponent } from "vue";
import router from "@/router";
export default defineComponent({
  props: ["newsModule", "newsList", "titleFlag"],
  setup() {
    const newsDetail = (data: any) => {
      router.push({
        name: "newsDetail",
        query: {
          articleId: data.article_id
        }
      });
    };
    return {
      newsDetail
    };
  }
});
